import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, Key, Building2, Package } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <Clock className="w-8 h-8 text-depto-amber" data-id="element-43" />,
    title: 'El Protocolo Express de 15 Minutos',
    desc: 'La rutina exacta de olfato y calma que tenés que hacer antes de salir para que él se quede durmiendo.'
  }, {
    icon: <Key className="w-8 h-8 text-depto-amber" data-id="element-44" />,
    title: 'Desensibilización de Llaves',
    desc: 'Cómo lograr que el sonido de tus llaves o el timbre del ascensor dejen de dispararle un ataque de pánico.'
  }, {
    icon: <Building2 className="w-8 h-8 text-depto-amber" data-id="element-45" />,
    title: 'Guía de Supervivencia en Consorcios',
    desc: 'Qué decirle (y qué no) a ese vecino que se queja para evitar multas o problemas legales.'
  }, {
    icon: <Package className="w-8 h-8 text-depto-amber" data-id="element-46" />,
    title: 'Recetario de Juguetes Caseros',
    desc: 'Cómo armar dispositivos de búsqueda con cosas que tenés en tu casa (toallones viejos, cajas de cartón, botellas).'
  }];
  return <section className="py-12 sm:py-24 px-5 sm:px-8 max-w-5xl mx-auto" data-id="element-47">
      <FadeIn data-id="element-48">
        <h2 className="text-2xl sm:text-4xl text-depto-brown mb-8 sm:mb-16 text-center" data-id="element-49">
          Lo que vas a lograr con este Kit Digital:
        </h2>
      </FadeIn>

      <div className="grid gap-8 sm:grid-cols-2" data-id="element-50">
        {features.map((feat, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-51">
            <div className="flex gap-6 bg-white p-8 rounded-3xl shadow-sm border border-depto-brown/5 h-full hover:shadow-md transition-shadow" data-id="element-52">
              <div className="flex-shrink-0 bg-depto-beige p-4 rounded-2xl h-fit" data-id="element-53">
                {feat.icon}
              </div>
              <div data-id="element-54">
                <h3 className="font-bold text-depto-brown text-xl mb-3" data-id="element-55">
                  {feat.title}
                </h3>
                <p className="text-depto-brown/70 leading-relaxed" data-id="element-56">
                  {feat.desc}
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}